<section class="dicom">
    <header class="dicom__header header">
        <button
            class="header__button menu-open"
            type="button"
            [disabled]="phase !== 'VIEWING'"
            (click)="onMenuMobileButtonClick($event)"
        >
            <img src="./assets/icons/documents/dicom-series.svg" alt="Серии" />
        </button>
        <span class="header__title">
            {{ phase === "VIEWING" ? currentIndex + 1 + " серия" : "DICOM" }}
        </span>
        <button
            class="header__button modal-close"
            type="button"
            (click)="closeApp($event)"
        >
            <img src="./assets/icons/actions/close-viewer.svg" alt="Закрыть" />
        </button>
    </header>

    <div class="dicom__state" *ngIf="phase !== 'VIEWING'" [ngSwitch]="phase">
        <div class="state-panel" *ngSwitchCase="'SELECT_STUDY'">
            <h2 class="state-panel__title">Выберите исследование</h2>
            <p class="state-panel__text">
                Для этой записи найдено несколько исследований.
            </p>
            <ul class="study-list">
                <li *ngFor="let study of studies; trackBy: trackStudy">
                    <button
                        class="study-list__item"
                        type="button"
                        [disabled]="selectingStudyRef !== null"
                        (click)="selectStudy(study)"
                    >
                        <span class="study-list__description">
                            {{ study.description || "Исследование без описания" }}
                        </span>
                        <span>{{ formatStudyDate(study.studyDate) }}</span>
                        <span *ngIf="study.modalities.length">
                            {{ study.modalities.join(", ") }}
                        </span>
                        <span *ngIf="study.institutionName">
                            {{ study.institutionName }}
                        </span>
                        <span *ngIf="selectingStudyRef === study.studyRef">
                            Выбор...
                        </span>
                    </button>
                </li>
            </ul>
            <button
                *ngIf="nextPageRef"
                class="state-panel__button"
                type="button"
                [disabled]="loadingMoreStudies"
                (click)="loadMoreStudies()"
            >
                {{ loadingMoreStudies ? "Загрузка..." : "Показать ещё" }}
            </button>
        </div>

        <div class="state-panel" *ngSwitchCase="'NOT_FOUND'">
            <h2 class="state-panel__title">Исследование не найдено</h2>
            <p class="state-panel__text">
                Для этой записи истории нет доступных DICOM-данных.
            </p>
        </div>

        <div class="state-panel" *ngSwitchCase="'ERROR'">
            <h2 class="state-panel__title">Не удалось открыть исследование</h2>
            <p class="state-panel__text">{{ errorMessage }}</p>
            <button class="state-panel__button" type="button" (click)="retry()">
                Повторить
            </button>
        </div>

        <div class="state-panel" *ngSwitchCase="'DOWNLOAD_READY'">
            <h2 class="state-panel__title">Архив подготовлен</h2>
            <p class="state-panel__text">Загрузка архива началась.</p>
        </div>

        <div class="state-panel" *ngSwitchDefault>
            <div class="state-panel__spinner"></div>
            <p class="state-panel__text" [ngSwitch]="phase">
                <ng-container *ngSwitchCase="'RESOLVING'">
                    Поиск исследования...
                </ng-container>
                <ng-container *ngSwitchCase="'LOADING_SERIES'">
                    Загрузка списка серий...
                </ng-container>
                <ng-container *ngSwitchCase="'PREPARING_SERIES'">
                    Подготовка снимков...
                </ng-container>
                <ng-container *ngSwitchCase="'PREPARING_ARCHIVE'">
                    Подготовка архива...
                </ng-container>
            </p>
            <p class="state-panel__progress" *ngIf="preparationProgress !== null">
                {{ preparationProgress }}%
            </p>
        </div>
    </div>

    <div class="dicom__body">
        <div
            class="dicom__sidebar sidebar"
            [ngClass]="{ 'mobile--opened': seriesbarMenuOpened }"
        >
            <ul class="dicom__info info">
                <li class="info__item">Пациент: {{ patient.name }}</li>
                <li class="info__item">
                    Дата рождения: {{ patient.birthdate }}
                </li>
                <li class="info__item" *ngIf="selectedStudy">
                    Дата исследования:
                    {{ formatStudyDate(selectedStudy.studyDate) }}
                </li>
            </ul>

            <div class="dicom__seriesbar seriesbar">
                <ul class="seriesbar__switch">
                    <li
                        *ngFor="let item of series; index as i; trackBy: trackSeries"
                        class="seriesbar__item"
                        [ngClass]="{
                            'seriesbar__item--active': i === currentIndex,
                            'seriesbar__item--disabled': !item.viewerSupported
                        }"
                        (click)="switchSerie(i, $event)"
                    >
                        <span>{{ item.description || "Серия " + (i + 1) }}</span>
                        <small *ngIf="item.modality">{{ item.modality }}</small>
                    </li>
                </ul>
            </div>
        </div>

        <div class="dicom__viewlayer" (wheel)="onViewWheel($event)">
            <div [id]="layerDivID"></div>
            <div *ngIf="phase === 'PREPARING_SERIES'" class="viewlayer__loader">
                <span>Подготовка кадров</span>
                <span class="viewlayer__progress" #loaderSeriesProgress>0</span>
            </div>
        </div>

        <div class="dicom__framebar framebar" *ngIf="frameCount > 0">
            <div class="framebar__display">
                <span class="framebar__display--current">
                    {{ currentFrame + 1 }}
                </span>
                /<span class="framebar__display--total">{{ frameCount }}</span>
            </div>

            <input
                type="range"
                class="framebar__scroll input-range"
                [style.width.px]="inputFrameWidth"
                [style.right.px]="-inputFrameWidth / 2"
                min="0"
                [max]="frameCount - 1"
                #frameScrollInput
                (input)="onFrameInputChange($event)"
            />
        </div>
    </div>
</section>
